/* Maisie's Munch: fill in a Munch from a QR code made on the trade show iPad (Munch Menu).
   The QR opens /products/<munch>?mmpick=Name 1|Name 2|... and this chooses each person's drawing
   through the builder's own search and results (mm-dynamic-menu.js is not changed), so a name
   that no longer matches a drawing is simply left for the customer to pick.
   Names, size and frame are still chosen by the customer here. */
(function () {
  var raw;
  try { raw = new URLSearchParams(window.location.search).get('mmpick'); } catch (e) { return; }
  if (raw === null) return;
  // Through the fair offer's /discount/ link Shopify encodes the link once more, so "&" can arrive as %26.
  var picks = raw.split('|').map(function (s) {
    if (/%[0-9a-f]{2}/i.test(s)) { try { s = decodeURIComponent(s); } catch (e) {} }
    return s.trim();
  });
  var tries = 0, offer = '';
  try { offer = (new URLSearchParams(window.location.search).get('mmoffer') || '').replace(/[^A-Za-z0-9-]/g, '').slice(0, 30); } catch (e) {}

  // Mark the basket as started from the stand iPad (2 Nov 2026). A cart attribute goes onto the order
  // as "Additional details" whatever discount code the customer ends up using, so Maisie's sales
  // dashboard can count it as a stand sale. It changes nothing the customer sees.
  // The fair offer is two codes, because Shopify cannot put 10% off and free postage in one: SPIRIT
  // (10%) and POST (free UK postage). The QR link applies SPIRIT; this adds POST beside it.
  var EXTRA_CODES = { SPIRIT: 'POST' };
  try {
    var update = { attributes: { 'Came from': 'Stand iPad' + (offer ? ' (' + offer + ')' : '') } };
    if (offer && EXTRA_CODES[offer.toUpperCase()]) update.discount = offer.toUpperCase() + ',' + EXTRA_CODES[offer.toUpperCase()];
    fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(update)
    }).catch(function () {});
  } catch (e) {}

  function choose(num, name) {
    var input = document.getElementById('mm-q-' + num);
    var box = document.getElementById('mm-dropdown-' + num);
    if (!input || !box || !name) return false;
    input.value = name;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    var want = name.toLowerCase();
    var opts = box.querySelectorAll('.mm-option[data-name]');
    for (var i = 0; i < opts.length; i++) {
      if (opts[i].getAttribute('data-name').toLowerCase() === want) { opts[i].click(); return true; }
    }
    return false; // the search results stay open with the closest matches
  }

  // The note goes above "Your print" (size, frame, proof), which comes before the people.
  function note(chosen, wanted) {
    var form = document.getElementById('mm-drink-form');
    if (!form || document.getElementById('mm-prefill-note')) return null;
    var el = document.createElement('div');
    el.id = 'mm-prefill-note';
    el.className = 'mm-prefill-note';
    el.setAttribute('role', 'status');
    el.style.cssText = 'background:#fff9ea;border:1.5px solid #708238;border-radius:12px;padding:12px 14px;margin:0 0 16px;' +
      'color:#5a3e2b;font-size:15px;line-height:1.45;';
    var names = document.querySelector('[id^="mm-name-"]') ? 'add each name, ' : ''; // Personalities have no names
    var people = document.querySelectorAll('.mm-person').length || wanted;
    el.textContent = chosen >= people
      ? 'Your picks from Maisie’s stand are filled in. Choose the size and frame, ' + names + 'then add it to your basket.'
      : 'Your picks from Maisie’s stand are filled in for ' + chosen + ' of the ' + people + '. Choose drawings for the rest, the size and frame, ' + names + 'then add it to your basket.';
    if (offer) el.textContent += ' Free delivery (code ' + offer + ') is added for you at checkout.';
    var print = document.querySelector('.mm-step-title--print');
    if (print && print.parentNode) print.parentNode.insertBefore(el, print);
    else form.insertBefore(el, form.firstChild);
    return el;
  }

  (function wait() {
    if (!document.getElementById('mm-q-1')) {
      if (tries++ < 600) setTimeout(wait, 100); // menu loads first, plus the script's own retries (up to 60s)
      return;
    }
    var wanted = 0, chosen = 0;
    picks.forEach(function (name, i) {
      if (!name) return;
      wanted++;
      if (choose(i + 1, name)) chosen++;
    });
    var el = wanted ? note(chosen, wanted) : null;
    if (el && el.scrollIntoView) setTimeout(function () { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 300);
  })();
})();
